import MoltenCore from '@leverege/molten-core';
import ReactDOMClient from 'react-dom/client';

// eslint-disable-next-line import/no-cycle
import PluginSetup from "./PluginSetup.js";
import Mutators from "./mutators/index.js";
import AuthCheckScreen from "./screens/AuthCheckScreen.js";
import Defaults from "./Defaults.js";
export default class Molten extends MoltenCore {
  /**
   * This will set the configuration for Molten and load
   * the default Plugins. After this, custom plugins should
   * be loaded
   */
  init(config) {
    super.init(config);
    const internalMutators = Object.values(Mutators);
    this.mutators = [...this.mutators, ...internalMutators];
    if (config?.loadDefaultPlugins !== false) {
      PluginSetup.install(this);
    }
  }
  render(rootComponent) {
    const targetId = this.getConfig('molten/targetId', 'root');
    const container = document.getElementById(targetId);
    const root = ReactDOMClient.createRoot(container);
    root.render(rootComponent);
  }
  getAppClass() {
    return AuthCheckScreen;
  }
  getDefault(module, key) {
    return Defaults?.[module]?.[key];
  }
}